import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Actions", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, { type: "" }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(`${_ctx.props.seletedNums} selecteds`) + " ", 1),
      _createVNode(_component_el_divider, { direction: "vertical" }),
      _hoisted_1,
      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
        default: _withCtx(() => [
          _createVNode(_component_arrow_down)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}